import React from "react";

import { CTooltip } from "@coreui/react";

import { TooltipProps } from "../../models/coreuicomponents.models";

const Tooltip: React.FC<TooltipProps> = ({ content, placement, children }) => {
  return (
    <CTooltip content={content} placement={placement}>
      {children}
    </CTooltip>
  );
};

export default Tooltip;
